import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { SharedService } from "app/services/core/shared.service";
import { ReportsService } from "app/services/reports/reports.service";


@Component({
  selector: 'app-mailingLabels',
  templateUrl: './mailingLabels.component.html',
  styleUrls: ['./mailingLabels.component.scss'],
})

export class MailingLabelsComponent implements OnInit {

  reportGroup = new UntypedFormGroup({
    StateNumbers: new UntypedFormControl('',[Validators.maxLength(4000)]),
    RowOffset1: new UntypedFormControl('0'),
    LabType: new UntypedFormControl('10'),
    RowOffset2: new UntypedFormControl('0'),
  });

  constructor(public reportsService: ReportsService,
    public sharedService: SharedService) { };

  ngOnInit(): void {
  }

  runReport1() {
    let stateNum = this.reportGroup.controls['StateNumbers'].value;
    let row = this.reportGroup.controls['RowOffset1'].value;

    this.reportsService.getMailingLabels(row, stateNum).subscribe(
      response => {
        this.downloadFile("MailingReport", response);
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  runReport2() {
    let type = this.reportGroup.controls['LabType'].value;
    let row = this.reportGroup.controls['RowOffset2'].value;

    this.reportsService.getSpecificMailingLabels(row, type).subscribe(
      response => {
        this.downloadFile("MailingReport", response);
      },
      error => console.log('error', error),
      () => {
      }
    );

  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

}
